import template from './ecocode-trustpilot-first-run-wizard-modal.html.twig';
import './ecocode-trustpilot-first-run-wizard-modal.scss';

const { Component } = Shopware;

Component.register('ecocode-trustpilot-first-run-wizard-modal', {
    template,
    metaInfo() {
        return {
            title: this.title
        };
    },
    data() {
        return {
            show: true,
            title: 'No title defined',
            buttonConfig: [],
            stepVariant: 'info',
            currentStep: {
                name: '',
                variant: 'large',
                navigationIndex: 0
            },
            stepper: {
                welcome: {
                    name: 'ecocode.trustpilot.setup.welcome',
                    variant: 'large',
                    navigationIndex: 0
                },
                connect: {
                    name: 'ecocode.trustpilot.setup.connect',
                    variant: 'large',
                    navigationIndex: 1
                },
                configure: {
                    name: 'ecocode.trustpilot.setup.configure',
                    variant: 'large',
                    navigationIndex: 2
                },
                invitation: {
                    name: 'ecocode.trustpilot.setup.invitation',
                    variant: 'large',
                    navigationIndex: 3
                },
                finish: {
                    name: 'ecocode.trustpilot.setup.finish',
                    variant: 'large',
                    navigationIndex: 4
                }
            }
        };
    },

    computed: {
        columns() {
            const res = this.showSteps
                ? '1fr 4fr'
                : '1fr';

            return res;
        },

        variant() {
            const { variant } = this.currentStep;

            return variant;
        },

        showSteps() {
            const { navigationIndex } = this.currentStep;

            return navigationIndex !== 0;
        },

        buttons() {
            return {
                right: this.buttonConfig.filter((button) => button.position === 'right'),
                left: this.buttonConfig.filter((button) => button.position === 'left')
            };
        },

        stepIndex() {
            const { navigationIndex } = this.currentStep;

            if (navigationIndex < 1) {
                return 0;
            }

            return navigationIndex - 1;
        },

        stepInitialItemVariants() {
            const navigationSteps = [
                ['disabled', 'disabled', 'disabled'],
                ['info', 'disabled', 'disabled'],
                ['success', 'info', 'disabled'],
                ['success', 'success', 'info'],
                ['success', 'success', 'success']
            ];
            const { navigationIndex } = this.currentStep;

            return navigationSteps[navigationIndex];
        }
    },

    watch: {
        '$route'(to) {
            const toName = to.name.replace('ecocode.trustpilot.setup.', '');

            this.currentStep = this.stepper[toName];
        }
    },

    mounted() {
        const step = this.$route.name.replace('ecocode.trustpilot.setup.', '');

        this.currentStep = this.stepper[step];
    },

    methods: {
        close() {
            this.show = false;
            this.$nextTick(() => {
                this.$router.push({ name: 'ecocode.trustpilot.overview', query: { setupCancelled: 1 } });
            });
        },
        updateButtons(buttonConfig) {
            this.buttonConfig = buttonConfig;
        },
        onButtonClick(action) {
            if (typeof action === 'string') {
                this.redirect(action);
                return;
            }

            if (typeof action !== 'function') {
                return;
            }

            action.call();
        },

        redirect(routeName) {
            this.$router.push({ name: routeName });
        },

        setTitle(title) {
            this.title = title;
        }
    }
});

